module.exports = __webpack_public_path__ + "img/17.5eae371a.png";